import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ns-plus-button',
  templateUrl: './plus-button.component.html',
  styleUrls: ['./plus-button.component.scss']
})
export class PlusButtonComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
